import deepEqual from 'fast-deep-equal'
import React from 'react'
import type { ExtraType } from '../../types/table'
import { axiosPatch } from '../../util/api'
import { UpdateReportAdTypes } from '../../util/contstants'
import { InlineEditPopover } from '../bids/InlineEditPopover'
import { BidHistoryTooltip } from '../bid_history_tooltip'
import { Toasts } from '../toaster/Toast'

interface DailyBudgetChangeProps {
    campaign: any
    extra: any
    disabled: boolean
}

export class DailyBudgetChange extends React.Component<DailyBudgetChangeProps> {
    shouldComponentUpdate(nextProps: Readonly<DailyBudgetChangeProps>): boolean {
        return (
            !deepEqual(nextProps.campaign, this.props.campaign) ||
            !deepEqual(nextProps.extra, this.props.extra)
        )
    }

    render() {
        const { campaign, extra, disabled } = this.props

        return (
            <BidHistoryTooltip id={campaign.campaign_id} type={UpdateReportAdTypes.Campaigns}>
                <InlineEditPopover
                    disabled={disabled}
                    label="Daily budget"
                    value={campaign.daily_budget}
                    onSave={(cents) => updateDailyBudget(campaign.campaign_id, cents, extra)}
                />
            </BidHistoryTooltip>
        )
    }
}

const updateDailyBudget = (id: number, daily_budget: number, extra: ExtraType) =>
    axiosPatch(`campaigns/${id}`, { daily_budget })
        .then(() => {
            extra.mutateItems((prev) => {
                return prev.map((item) => {
                    if (item.campaign_id === id) {
                        return {
                            ...item,
                            daily_budget,
                        }
                    }

                    return item
                })
            })

            Toasts.success('Daily Budget successfully updated')
            extra.reload()
        })
        .catch((err) => {
            if (err.response?.status === 409) {
                const ids = Object.keys(err.response.data)

                Toasts.warning(
                    `${ids.length} items were out of sync. Please review the changes and retry`,
                )

                extra.reload()
            }
            throw err
        })
